import React from 'react'
import { Panel } from 'react-bootstrap'

export default function PasswordSecurity() {
  return (
    <Panel>
      <Panel.Body>
        <h4>Password Security</h4>

        <p>
          Passwords are a critical and important part of access to your internet
          account. Anyone who knows or can guess your password will have full
          access to make changes.
        </p>

        <p>
          Infinite Networks recommends that you use a Password Manager like{' '}
          <a
            href="https://1password.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            1Password
          </a>{' '}
          or{' '}
          <a
            href="https://www.lastpass.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            LastPass
          </a>{' '}
          to create and manage your passwords.
        </p>

        <p>You should never reuse a password for multiple services.</p>
      </Panel.Body>
    </Panel>
  )
}



// WEBPACK FOOTER //
// ./src/components/Signup/PasswordSecurity.jsx